<template>
  <div class="design-selection">
    <h5 class="stepName">{{ step.name }}</h5>
    <div
      v-for="section of step.sections.filter(filterSections)"
      class="selectionBody"
      :key="section.name"
    >
      <div
        v-for="category of section.categories.filter(filterCategories)"
        :key="category.name"
      >
        <span v-if="category.name && category.name !== step.name"
          class="categoryName">{{category.name}}</span>
        <span
          v-for="item of category.items.filter(filterItems)"
          :key="item.name"
        >
          <span
            v-if="step.name === specialCases.stepNames.thermalConstruction"
            class="selectionName"
          >
            <design-thermal
              :item="item"
            />
          </span>
          <span v-else class="selectionName">
            {{ item.name }}
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DesignThermal from '@/components/designReport/DesignThermal';

const filterItems = item => item.selected;
const filterCategories = category => category.selected && category.items.some(filterItems);
const filterSections = section => section.selected && section.categories.some(filterCategories);

export default {
  name: 'design-selection',
  props: {
    step: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState([
      'specialCases',
    ]),
  },
  methods: {
    filterSections,
    filterCategories,
    filterItems,
  },
  components: {
    DesignThermal,
  },
};
</script>

<style lang="scss">
.design-selection {
  display: flex;
  flex-flow: column;
  width: 100%;
  margin-bottom: 5px;

  h5,
  h6,
  span {
    margin: 0;
    text-transform: capitalize;
  }

  .stepName {
    background: #cccccc;
    font-size: 22px;
    font-weight: bold;
    color: white;
    text-indent: 2px;
    margin: 2px;
  }

  .selectionBody {
    font-size: 20px;
    color: black;
    margin-left: 10px;
    margin-top: 5px;

    .categoryName::after {
      content: ':';
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/designReport/DesignSelection.vue